export default {
      id: "footer_labels-usage",
      viewBox: "0 0 40 50",
      url: "../dist/images/" + "sprite.svg#footer_labels-usage",
      toString: function () {
        return this.url;
      }
    }